export default __webpack_public_path__ + "static/media/imdb.ba728ec2.png";